import { HiExclamationCircle } from 'react-icons/hi'
import { useMaintenanceMode } from '@/context/MaintenanceContext'
import './MaintenanceOverlay.css'

export default function MaintenanceOverlay() {
  const { active } = useMaintenanceMode()

  if (!active) return null

  return (
    <div className="maintenance-overlay" role="alert" aria-live="assertive">
      <section className="maintenance-overlay__panel" aria-labelledby="maintenance-overlay-title">
        <HiExclamationCircle className="maintenance-overlay__icon" aria-hidden="true" />
        <h1 id="maintenance-overlay-title" className="maintenance-overlay__title">
          Application under maintenance
        </h1>
        <p className="maintenance-overlay__message">
          Contact your system administrator for more details.
        </p>
      </section>
    </div>
  )
}
